import { render } from "./Ellipsis.vue?vue&type=template&id=1f594033"
import script from "./Ellipsis.vue?vue&type=script&lang=js"
export * from "./Ellipsis.vue?vue&type=script&lang=js"
script.render = render

export default script